const EVENT_TRACKING_NAME = 'MaintenanceHistory';
const EVENT_TRACKING_ACTIONS = {
  searchInputChanged: 'searchInputChanged',
  exportCSV: 'exportCSV',
  viewDetailsClicked: 'viewDetailsClicked',
  paginationChanged: 'paginationChanged',
  planNameClicked: 'planNameClicked',
  assetNameClicked: 'assetNameClicked',
  orderTableChanged: 'orderTableChanged',
};
const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  });
};
export default function MaintenanceHistoryController(
  $scope,
  $filter,
  MaintenanceService,
  gettextCatalog,
) {
  'ngInject';

  //Local Variables
  $scope.searchText = '';
  $scope.statusData = [];
  $scope.filteredStatusData = [];

  //Sorting
  $scope.predicate = 'equipment.name';
  $scope.reverse = true;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  //Sort filteredStatusData
  $scope.orderStatusData = function (predicate) {
    $scope.reverse = predicate === $scope.predicate ? !$scope.reverse : false;
    $scope.predicate = predicate;

    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.orderTableChanged,
      orderBy: predicate,
      descending: $scope.reverse,
    });
  };

  $scope.pageChanged = function () {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.paginationChanged,
      currentPage: $scope.currentPage,
    });
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.searchText) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.searchInputChanged,
      });
    }

    $scope.filteredStatusData = $filter('filter')($scope.statusData, $scope.searchText);
  };

  //$scope.statusData = [];
  //ON INIT
  var refresh = function () {
    $scope.loading = true;
    MaintenanceService.getHistory()
      .then(
        function (response) {
          $scope.statusData = response?.data?.map((item) => {
            return {
              ...item,
              completedAt: typeof item.completedAt === "undefined"?"":new Date($filter('TableDateFilter')(item.completedAt)),
              completed: item.completed
                ? gettextCatalog.getString('Completed')
                : gettextCatalog.getString('Incomplete'),
            };
          });

          $scope.filteredStatusData = $scope.statusData.slice();
        },
        function (error) {
          var errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving maintenance history data',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message + ' ' + error.status.toString();
            } else {
              errorMsg += ': ' + error.status.toString();
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.onLoadErrorFlag = true;
          $scope.onLoadErrorText = errorMsg;
        },
      )
      .finally(function () {
        $scope.loading = false;
      });
  };

  refresh();

  //CSV file
  $scope.getCsvFileName = function () {
    if (!$scope.statusData) return '';

    var fileName = gettextCatalog.getString('data_export');
    var name = gettextCatalog.getString('Maintenance History');
    return fileName + '.' + name + '.csv';
  };

  $scope.getCsvData = function () {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportCSV,
    });
    return [
      {
        Asset: 'Asset',
        Plan: 'Plan',
        Status: 'Status',
        'Completed At': 'Completed At',
      },
      ...GetOrderedCSVList(),
    ];
  };

  function GetOrderedCSVList() {
    const list = $filter('orderBy')($scope.filteredStatusData, $scope.predicate, $scope.reverse);
    return list.map((item) => {
      return {
        Asset: item.equipment.name,
        Plan: item.plan.name,
        Status: item.completed,
        completedAt: item.completedAt,
      };
    });
  }

  $scope.viewDetailsClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.viewDetailsClicked,
      id: id,
    });
  };

  $scope.assetNameClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.assetNameClicked,
      equipmentId: id,
    });
  };

  $scope.planNameClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.planNameClicked,
      planId: id,
    });
  };
}
